module.exports = __webpack_public_path__ + "img/journeypoint-black.3f3ecbb5.png";